import type { BuildStatus } from '../api/client';

interface StatusMeta {
  label: string;
  cls: string;
  dotCls: string;
}

const STATUS_META: Record<BuildStatus, StatusMeta> = {
  idle: { label: '待构建', cls: 'status-idle', dotCls: 'dot-idle' },
  uploading: { label: '上传中', cls: 'status-building', dotCls: 'dot-building' },
  building: { label: '构建中', cls: 'status-building', dotCls: 'dot-building' },
  success: { label: '已就绪', cls: 'status-ready', dotCls: 'dot-ready' },
  failed: { label: '失败', cls: 'status-failed', dotCls: 'dot-failed' },
};

/** 状态文案，供表格等场景在不使用徽章组件时复用 */
export function statusLabel(status: BuildStatus): string {
  return STATUS_META[status]?.label ?? status;
}

export default function StatusBadge({ status }: { status: BuildStatus }) {
  const meta = STATUS_META[status] ?? {
    label: status,
    cls: 'status-idle',
    dotCls: 'dot-idle',
  };
  return (
    <span className={`status-badge ${meta.cls}`}>
      <span className={`status-dot ${meta.dotCls}`} />
      {meta.label}
    </span>
  );
}
